import { widgetSelector } from './helpers';

/**
 *  For widgets, that having `style` property, a.k.a. "offsets"
 *  use auto value instead calculated
 */
export function styleOverride(widget) {
  const { style } = widget;
  const rules = [];
  const selector = widgetSelector(widget);

  if (!style) {
    return rules;
  }

  const overrides = [
    ['top', style.top],
    ['right', style.right],
    ['bottom', style.bottom],
    ['left', style.left],
  ].filter(([, property]) => property !== undefined);

  if (overrides.length > 0) {
    const props = new Map([
      ['top', 'initial'],
      ['right', 'initial'],
      ['bottom', 'initial'],
      ['left', 'initial'],
    ]);
    overrides.forEach(([propName, propValue]) => {
      props.set(propName, propValue);
    });

    const properties = Array.from(props.entries());

    rules.push([selector, properties]);

    rules.push([
      selector,
      properties.map(([propName, propVal]) => {
        const val = parseInt(propVal);
        if (isNaN(val)) {
          return [propName, propVal];
        }
        return [propName, `${val * 1.5}px`];
      }),
      '@media screen and (min-width: 1920px)',
    ]);
  }
  return rules;
}
